<template>
<div>
  <div>
    <div class="text-right p-0">
        <Button
        v-if="areConsigneesAvailable"
        :disabled="disabled"
        type="primary"
        size="small"
        @click="showPopup"><span class="loadspin"
        v-show="fetching" :key="elementkey"></span>{{$t('INDENT_SUBMIT')}}</Button>
      </div>
    <div class="row-edit my-10">
      <div class="row-edit-badge">
        <div class="row-edit-badge-section">
          <span v-if="!areConsigneesAvailable">
            No accessible destinations
          </span>
          <template v-else>
          <Rows
              v-for="(consignee, index) in consignees"
              :consignee="consignee"
              :movement="order.movement"
              :datePickerFormat="datePickerFormat"
              v-on:change="change"
              :getBackDateConfig="getBackDateConfig"
              :dispatch="date"
              v-bind:key="index"
            />
          </template>
        </div>
      </div>
      <h4 class="text-grey-dark3 text-sm mb-20" style="font-weight:normal;">{{$t('INDENT_NOTE')}} : {{$t('INDENT_REPORTED_POD_TIME_DEFAULTS_TO_GEO_FENCE_TIME')}}</h4>
      <div class="popover-custom no-border with-shadow"
            placement="bottom" v-if="showAlertFlag">
          <div class="popover-body bg-white w-300">
            <p>
              {{$t('TRUCK_DETAINED_CHECK',
              { n: this.truckDetainedConfig.no_of_day })}}
            </p>
            <div class="popover-footer">
              <Button type="text" size="mini"  @click="showAlertFlag=false">
                {{$t('INDENT_NO')}}
              </Button>
              <Button type="primary" size="mini" @click="onSubmit">
          {{$t('INDENT_YES_PROCEED')}}
              </Button>
            </div>
          </div>
    </div>
    </div>
  </div>
  <div class="clearfix my-10" v-if="!order.seal_number_at_destination && order.seal_number_at_source">
      <h5 class="header-stripe">
        <span>{{$t('INDENT_SEAL_NUMBER').toUpperCase()}}</span>
        <div class="action">
          <span v-if="sealNo">
            <Button type="primary" size="mini" @click="sealNumberCheck">{{$t('INDENT_UPDATE')}}</Button>
          </span>
        </div>
      </h5>
      <div class="my-10">
        <label class="label-md mr-10">{{$t('INDENT_IS_SEAL_NUMBER_INTACT')}}</label>
        <Radio :label="true" v-model="isSealNumberIntact">
        {{$t('INDENT_YES')}}
        </Radio>
        <Radio :label="false" v-model="isSealNumberIntact">
        {{$t('INDENT_NO')}}
        </Radio>
      </div>
      <Form :inline="true" class="form-default form-triple">
        <FormItem :label="$t('SEAL_NUMBER')">
          <Input :placeholder="$t('ENTER_SEAL_NUMBER')" type="text" v-model="sealNo"></Input>
        </FormItem>
      </Form>
      <div class="popover-custom no-border with-shadow"
            placement="bottom" v-if="sealAlertFlag">
          <div class="popover-body bg-white w-300">
            <p>
              {{$t('CONFIRMATION_POPUP_TRANSPORTER_DEBITED')}}
            </p>
            <div class="popover-footer">
              <Button type="text" size="mini"  @click="sealAlertFlag=false">
                {{$t('INDENT_NO')}}
              </Button>
              <Button type="primary" size="mini" @click="updateSealNumberDetails">
          {{$t('INDENT_YES_PROCEED')}}
              </Button>
            </div>
          </div>
    </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { uniqBy } from 'lodash';
import Header from '../../orders/markasdelivered/Header';
import Rows from '../../orders/markasdelivered/Row';
import { oneDayMilliSeconds } from '../../../constants/order';
import moment from 'moment';

export default {
  props: ['order', 'getBackDateConfig', 'inbound', 'isPrimary', 'datePickerFormat', 'truckDetainedConfig'],
  components: {
    Header,
    Rows,
  },
  data() {
    return {
      disabled: false,
      fetching: false,
      elementkey: 0,
      payload: [],
      sectionType: { DEPOT: 1 },
      showAlertFlag: false,
      isGeofencePopulated: false,
      isSealNumberIntact: null,
      sealNo: null,
      sealAlertFlag: false,
    };
  },
  computed: {
    ...mapGetters({
      currentUserDepots: 'app/depots',
      OtherUserDepots: 'app/otherDepots',
      configurations: 'app/configurations',
      currentUser: 'app/currentUser',
    }),
    date() {
      const maxGateTruckOut = new Date(
        this.$moment.max(
          this.order.sources.map(_sources => this.$moment(_sources.dispatched_at)),
        ),
      );
      // this.$moment(this.startDate).toISOString()
      return maxGateTruckOut;
    },
    hasGateAccess() {
      return (this.currentUser && this.currentUser.gate_associates_ids) && this.currentUser.gate_associates_ids.length;
    },
    areConsigneesAvailable() {
      return !!(this.consignees && this.consignees.length);
    },
    consignees() {
      const destinations = (this.order && this.order.destinations) || [];
      if (this.inbound && this.order && this.order.destinations && this.order.destinations.length) {
        const applyFilter = this.hasGateAccess ? this.hasUserDepotGateAccess : this.hasUserDepotAccess;
        const accessDestinations = this.order.destinations.filter(applyFilter);
        if (this.hasGateAccess || this.isMultiDropConfig) {
          return this.getGateWiseDestinations(accessDestinations);
        }
        return uniqBy(accessDestinations, 'location_id');
      } else if (this.isMultiDropConfig) {
        return this.getGateWiseDestinations(destinations);
      }
      return uniqBy(destinations, 'location_id');
    },
    isMultiDropConfig() {
      return this.configurations && this.configurations.multi_drop_at_gate_level;
    },
  },
  methods: {
    getGateWiseDestinations(destinations) {
      return uniqBy(destinations.map((dropLocation) => {
        let dropLocationRefId = dropLocation.details.reference_id || '-';
        const dropLocationName = dropLocation.details.name || '-';
        if (dropLocation.gate_id) {
          const dropDestinationDetails = this.OtherUserDepots.find(val => val.id === dropLocation.location_id);
          if (dropDestinationDetails && dropDestinationDetails.gates) {
            const gateDetails = dropDestinationDetails ? dropDestinationDetails.gates.find(gate => gate.id === dropLocation.gate_id) :
              { reference_id: dropLocation.details.reference_id };
            dropLocationRefId = `${gateDetails && gateDetails.reference_id} - ${dropLocationName}`;
          }
        }
        return { ...dropLocation,
          dropLocationRefId,
          dropLocationName,
          dropLocationLabel: `${dropLocationName} - ${dropLocationRefId}` };
      }), 'dropLocationRefId');
    },
    change(selected) {
      const payload = this.payload;
      const idx = payload.findIndex((val) => {
        if (this.isMultiDropConfig || this.hasGateAccess) {
          return val.destination_id === selected.destination_id &&
            val.gate_id === selected.gate_id;
        }
        return val.destination_id === selected.destination_id;
      });
      if (idx !== -1) {
        payload.splice(idx, 1, selected);
      } else {
        payload.push(selected);
      }
      if (payload.some(val => !!val.geofence_populated)) {
        this.isGeofencePopulated = true;
      } else {
        this.isGeofencePopulated = false;
      }
    },
    hasUserDepotGateAccess(destination) {
      const gateIds = this.currentUser.gate_associates_ids;
      return destination.type === this.sectionType.DEPOT && gateIds.includes(destination.gate_id);
    },
    hasUserDepotAccess(destination) {
      const hasDepotAccess =
      this.currentUserDepots && this.currentUserDepots.length;
      const depotIds = this.currentUserDepots.map(_depot => _depot.id);
      return destination.type === this.sectionType.DEPOT &&
      hasDepotAccess ? depotIds.includes(destination.location_id) : true;
    },
    arrivedDateValidation(time, reportedDateAllow, truckDispatched) {
      if (reportedDateAllow) {
        return time.getTime() < Date.now() - oneDayMilliSeconds || time.getTime() > new Date();
      }
      return time.getTime() > Date.now() ||
        time.getTime() < new Date(truckDispatched).getTime() - oneDayMilliSeconds;
    },
    dispatchedDateValidation(time, releaseDateAllow, dispatch, truckDispatched) {
      if (releaseDateAllow) {
        return time.getTime() < Date.now() - oneDayMilliSeconds || time.getTime() > new Date();
      }
      if (!dispatch) {
        return time.getTime() > Date.now() ||
          time.getTime() < new Date(truckDispatched).getTime() - oneDayMilliSeconds;
      }
      return time.getTime() > new Date() ||
        time.getTime() < new Date(dispatch).getTime() - oneDayMilliSeconds;
    },
    toggle() {
      this.disabled = true;
      this.fetching = true;
    },
    toggleback() {
      this.disabled = false;
      this.fetching = false;
    },
    computeDiffBetweenDays(startDay, endDay) {
      if (!startDay || !endDay) {
        return 0;
      }
      return moment(endDay).diff(moment(startDay), 'days');
    },
    showPopup() {
      const istruckDetainedConfigEnabled = this.truckDetainedConfig &&
       this.truckDetainedConfig.enabled;
      if (istruckDetainedConfigEnabled) {
        // compute diff of truck in and truck out and compare if greater than the configured n
        const isExceedThreshold = this.payload
          .filter(consignee => consignee.reported_at && consignee.release_at)
          .find(consignee =>
            this.computeDiffBetweenDays(consignee.reported_at, consignee.release_at) >=
           this.truckDetainedConfig.no_of_day);
        if (isExceedThreshold) {
          this.showAlertFlag = true;
        }
      }
      if (!(this.order.seal_number_at_destination) && this.$hasFeature('allow_seal_number') &&
      this.order.vehicle_type.seal_available) {
        this.$errorMessage({ message: this.$t('ENTER_DESTINATION_SEAL_NUMBER') });
        this.disabled = true;
        return;
      }
      if (!this.showAlertFlag) {
        this.onSubmit();
      }
    },
    async onSubmit() {
      this.showAlertFlag = false;
      this.toggle();
      try {
        if (this.payload.some(source => new Date(source.reported_at).getTime() > new Date().getTime()) ||
          this.payload.some(source => new Date(source.release_at).getTime() > new Date().getTime())) {
          this.$errorMessage({ message: this.$t('INDENT_REPORTED_RELEASE_FUTURE_TIME_ERROR_MSG') });
          this.toggleback();
          return;
        }
        if (this.payload.some(source => source.reported_at < this.date)) {
          this.$errorMessage({ message: this.$t('INDENT_REPORTED_AFTER_DISPATCHED_ERROR_MSG') });
          this.toggleback();
          return;
        }
        if (this.payload.some(source => source.release_at < source.reported_at)) {
          this.$errorMessage({ message: this.$t('INDENT_RELEASE_AFTER_REPORTED_ERROR_MSG') });
          this.toggleback();
          return;
        }
        if (this.payload.some(source => source.unloading_start_at > source.release_at ||
          source.unloading_start_at < source.reported_at)) {
          this.$errorMessage({ message: this.$t('INDENT_UNLOADING_START_BTWN_REPORTED_RELEASE') });
          this.toggleback();
          return;
        }
        if (this.payload.some(source => source.unloading_end_at < source.unloading_start_at ||
          source.unloading_end_at > source.release_at)) {
          this.$errorMessage({ message: this.$t('INDENT_UNLOADING_END_BTWN_UNLOADING_START_RELEASE') });
          this.toggleback();
          return;
        }
        const payload = this.payload;
        const id = this.order.order_number;
        const result = await this.$store.dispatch('order/deliver', {
          id,
          data: payload,
        });
        //triggerIndentStatusUpdate
        await this.$store.dispatch('paymentsV2/updateIndentStatus', {
          id,
        });
        if (result && result.error) {
          this.toggleback();
          this.$error({ message: result.error });
        } else if (result.order_number) {
          this.$emit('done', 'markasdelivered');
          if (this.$hasFeature('exim_enabled') && result.master_indent) {
            await this.$store.dispatch('exim/fetchChildIndent', { indentNo: result.master_indent });
          }
          this.$success({
            message: this.$t('INDENT_MARK_AS_DELIVERED_TOAST_MSG', { order_number: result.order_number }),
          });
          this.toggleback();
        }
        return result;
      } catch (e) {
        this.toggleback();
        return e;
      }
    },
    sealNumberCheck() {
      if ((this.sealNo.toLowerCase() !== this.order.seal_number_at_source) ||
        !this.isSealNumberIntact) {
        this.sealAlertFlag = true;
      } else {
        this.updateSealNumberDetails();
      }
    },
    async updateSealNumberDetails() {
      try {
        const { order_number: orderNo } = this.order;
        const data = {
          seal_no: this.sealNo,
          update_in: 'destination',
          is_seal_number_intact: this.isSealNumberIntact,
        };
        const result = await this.$store.dispatch('order/updateSealNumberDetails', {
          orderNo,
          data,
        });
        if (result && result.order_no) {
          this.$emit('closeDrawer');
          this.$success({
            message: this.$t('INDENT_SEAL_NUMBER_UPDATE_TOAST_MSG', { order_number: result.order_no }),
          });
        } else if (result && result.error) {
          this.$error({
            message: result.error,
          });
        }
      } catch (error) {
        // console.log(error);
      }
    },
  },
};
</script>
